import { render, staticRenderFns } from "./EnrollmentAccountEmail.vue?vue&type=template&id=4524bf60&scoped=true&"
import script from "./EnrollmentAccountEmail.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentAccountEmail.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentAccountEmail.vue?vue&type=style&index=0&id=4524bf60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524bf60",
  null
  
)

export default component.exports